<template>
    <div class="product-meta" v-if="showStock">
        <span class="badge" v-if="isInStock">
            {{ textInStock }}
        </span>
        <span class="badge out-of-stock" v-else-if="restockDay !== null && restockDay > 0 && !isInStock">
            Dodanie do {{ getRestockDate() }}
        </span>
        <span class="badge out-of-stock" v-else>
            {{ textOutOfStock }}
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            isInStockProp: {
                required: true,
                type: String
            },
            restockDayProp: {
                required: false,
                type: String,
                default: null
            },
            textInStock: {
                required: true,
                type: String,
            },
            textOutOfStock: {
                required: true,
                type: String
            },
            productType: {
                required: true
            }
        },

        data() {
            return {
                isInStock: this.isInStockProp,
                restockDay: this.restockDayProp,
                showStock: true
            }
        },

        mounted() {
            this.$root.$on('setProduct', (data) => {
                this.restockDay = data.productRestockDay
                this.isInStock = data.productStock
                this.showStock = true
            });

            if ( this.productType == 1 )
                this.showStock = false
        },

        methods: {

            getRestockDate() {
                let count = 0;
                let date = new Date();

                while ( count < this.restockDay ) {

                    date.setDate(date.getDate() + 1);

                    // Skip weekends
                    if ( date.getDay() !== 0 && date.getDay() !== 6 )
                        count++;
                }

                return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
            }
        }
    }
</script>
